import { OrderSide } from '@shared-types';
import { IOrderFormConfig, OrderFormType } from '../../../models/order-form.model';

export const ORDER_FORM_CONFIGS: Record<OrderFormType, IOrderFormConfig> = {
	[OrderFormType.DEPOSIT]: {
		type: OrderFormType.DEPOSIT,
		sideInfo: {
			[OrderSide.Buy]: {
				actions: {
					SUBMIT: {
						id: 'NORMAL_SUBMIT',
						action: 'SUBMIT',
						label: 'ارسال خرید',
						class: 'w-full',
						cyTag: 'oms-order-form-submit-button-buy',
						variant: 'green',
						confirmBeforeAction: false
					},
					CANCEL: {
						id: 'NORMAL_CANCEL',
						action: 'CANCEL',
						label: 'انصراف',
						class: '',
						cyTag: 'oms-order-form-cancel-button-buy',
						variant: 'mute',
						confirmBeforeAction: false
					},
					EDIT: {
						id: 'NORMAL_EDIT',
						action: 'EDIT',
						label: 'ویرایش خرید',
						class: 'w-full',
						cyTag: 'oms-order-form-edit-button-buy',
						variant: 'green',
						confirmBeforeAction: false
					},
					CLOSE: {
						id: 'NORMAL_CLOSE',
						action: 'CLOSE',
						label: 'بستن',
						class: '',
						cyTag: 'oms-order-form-cancel-button-buy',
						variant: 'mute',
						confirmBeforeAction: false
					}
				}
			},
			[OrderSide.Sell]: {
				actions: {
					SUBMIT: {
						id: 'NORMAL_SUBMIT',
						action: 'SUBMIT',
						label: 'ارسال فروش',
						class: 'w-full',
						cyTag: 'oms-order-form-submit-button-sell',
						variant: 'red',
						confirmBeforeAction: false
					},
					CANCEL: {
						id: 'NORMAL_CANCEL',
						action: 'CANCEL',
						label: 'انصراف',
						class: '',
						cyTag: 'oms-order-form-cancel-button-sell',
						variant: 'mute',
						confirmBeforeAction: false
					},
					EDIT: {
						id: 'NORMAL_EDIT',
						action: 'EDIT',
						label: 'ویرایش فروش',
						class: 'w-full',
						cyTag: 'oms-order-form-edit-button-sell',
						variant: 'red',
						confirmBeforeAction: false
					},
					CLOSE: {
						id: 'NORMAL_CLOSE',
						action: 'CLOSE',
						label: 'بستن',
						class: '',
						cyTag: 'oms-order-form-cancel-button-sell',
						variant: 'mute',
						confirmBeforeAction: false
					}
				}
			}
		}
	},
	[OrderFormType.OPTION]: {
		type: OrderFormType.OPTION,
		sideInfo: {
			[OrderSide.Buy]: {
				actions: {
					SUBMIT: {
						id: 'OPTION_SUBMIT',
						action: 'SUBMIT',
						label: 'ارسال خرید',
						class: 'w-full',
						cyTag: 'option-order-form-submit-button-buy',
						variant: 'green',
						confirmBeforeAction: false
					},
					EDIT: {
						id: 'OPTION_EDIT',
						action: 'EDIT',
						label: 'ویرایش خرید',
						class: 'w-full',
						cyTag: 'oms-order-form-edit-button-buy',
						variant: 'green',
						confirmBeforeAction: false
					},
					CANCEL: {
						id: 'OPTION_CANCEL',
						action: 'CANCEL',
						label: 'انصراف',
						class: '',
						cyTag: 'option-order-form-cancel-button-buy',
						variant: 'mute',
						confirmBeforeAction: false
					},
					CLOSE: {
						id: 'OPTION_CLOSE',
						action: 'CLOSE',
						label: 'بستن',
						class: '',
						cyTag: 'option-order-form-cancel-button-buy',
						variant: 'mute',
						confirmBeforeAction: false
					}
				}
			},
			[OrderSide.Sell]: {
				actions: {
					SUBMIT: {
						id: 'OPTION_SUBMIT',
						action: 'SUBMIT',
						label: 'ارسال فروش',
						class: 'w-full',
						cyTag: 'option-order-form-submit-button-sell',
						variant: 'red',
						confirmBeforeAction: false
					},
					EDIT: {
						id: 'OPTION_EDIT',
						action: 'EDIT',
						label: 'ویرایش فروش',
						class: 'w-full',
						cyTag: 'oms-order-form-edit-button-sell',
						variant: 'red',
						confirmBeforeAction: false
					},
					CANCEL: {
						id: 'OPTION_CANCEL',
						action: 'CANCEL',
						label: 'انصراف',
						class: '',
						cyTag: 'option-order-form-cancel-button-sell',
						variant: 'mute',
						confirmBeforeAction: false
					},
					CLOSE: {
						id: 'OPTION_CLOSE',
						action: 'CLOSE',
						label: 'بستن',
						class: '',
						cyTag: 'option-order-form-cancel-button',
						variant: 'mute',
						confirmBeforeAction: false
					}
				}
			}
		}
	}
};
